import { Component, Input, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
    selector: 'app-toggle-instruction',
    templateUrl: './toggle-instruction.component.html',
    styleUrls: ['./toggle-instruction.component.scss'],
    standalone: false
})
export class ToggleInstructionComponent {
  private modalController = inject(ModalController);

  @Input() message: string;

  close() {
    this.modalController.dismiss();
  }
}
